import { useField, useFormikContext } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import classes from './Input.module.scss';
import Select from 'react-select';

import { get, sortBy } from 'lodash-es';

export const colourStyles = {
  control: (styles, { isDisabled }) => {
    return {
      backgroundColor: isDisabled ? '#F1F2F8' : '#f6f6f6',
      fontSize: '1vw',
      border: '1px solid #ebebeb',
      borderRadius: '0.5vw',
      height: '3.5vw',
      width: '100%',
      outline: 'none',
      display: 'flex',
      marginTop: '2.6vw',
    };
  },
  menu: (styles) => {
    return {
      fontSize: '1vw',
      backgroundColor: 'white',
      border: '1px solid #ccc',
      boxShadow: '0 1px 0 rgb(0 0 0 / 6%)',
      boxSizing: 'border-box',
      overflowY: 'auto',
      position: 'absolute',
      width: '100%',
      borderRadius: '0.5vw',
      zIndex: '1',
    };
  },
  menuList: (styles) => {
    return {
      ...styles,
      maxHeight: '10vw !important',
      overflowY: 'auto !important',
    };
  },
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      fontSize: '1vw',
      backgroundColor: isSelected ? '#f2f9fc' : '#fff',
      cursor: 'pointer',
      color: '#333',
      padding: '0.51vw 1vw',
    };
  },
  indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
};

export const topPlacementStyles = {
  control: (styles, { isDisabled }) => {
    return {
      backgroundColor: isDisabled ? '#F1F2F8' : 'white',
      fontSize: '1vw',
      border: '1px solid #ebebeb',
      borderRadius: '0.5vw',
      height: '2.6vw',
      outline: 'none',
      display: 'flex',
      marginTop: '0.51vw',
    };
  },
  menuList: (styles) => {
    return {
      ...styles,
      maxHeight: '10vw !important',
      overflowY: 'auto !important',
    };
  },
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      fontSize: '1vw',
      backgroundColor: isSelected ? '#f2f9fc' : '#fff',
      cursor: 'pointer',
      color: '#333',
      padding: '0.51vw 1vw',
    };
  },
  indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
};

export const Input = ({ label, customOnChange, hint, labelClassName, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div style={props.customStyles} className={classes.InputContainer}>
      {label && (
        <label
          htmlFor={props.name}
          className={labelClassName ? labelClassName : classes.InputContainerLabel}
        >
          {label} {props.required ? <span className='red'>*</span> : null}
        </label>
      )}
      <div>
        {!customOnChange ? (
          <>
            {props.prefix ? (
              <div className={classes.PhoneContainer}>
                <div className={classes.CountryCode}>{props.prefix}</div>
                <input
                  className={props.className ? props.className : classes.InputField}
                  type={props.type || 'text'}
                  {...field}
                  {...props}
                  id={props.name}
                  required={false}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            ) : (
              <input
                className={props.className ? props.className : classes.InputField}
                type={props.type || 'text'}
                {...field}
                {...props}
                id={props.name}
                required={false}
                onWheel={(e) => e.target.blur()}
              />
            )}
          </>
        ) : (
          <input
            type={props.type || 'text'}
            className={props.className ? props.className : classes.InputField}
            {...field}
            {...props}
            id={props.name}
            onChange={customOnChange}
            required={false}
            onWheel={(e) => e.target.blur()}
          />
        )}
        {meta.touched && meta.error ? <div className='error'>{meta.error}</div> : null}
        {Boolean(hint) && <div className='hint'>{hint}</div>}
      </div>
    </div>
  );
};

export const Textarea = ({ label, labelClassName, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div>
      <label
        htmlFor={props.name}
        className={labelClassName ? labelClassName : classes.InputContainerLabel}
      >
        {label} {props.required ? <span className='red'>*</span> : null}
      </label>
      <div>
        <textarea className={props.className ? props.className : ''} rows={4} {...field} {...props} id={props.name} required={false} />
        {meta.touched && meta.error ? <div className='error'>{meta.error}</div> : null}
      </div>
    </div>
  );
};

export const PhoneInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className={classes.InputContainer}>
      <label htmlFor={props.name}>
        {label} {props.required ? <span className='red'>*</span> : null}
      </label>
      <div className={classes.PhoneContainer}>
        <div className={classes.CountryCode}>+91</div>
        <input type='text' {...field} {...props} id={props.name} />
        {meta.touched && meta.error ? <div className='error'>{meta.error}</div> : null}
      </div>
    </div>
  );
};

export const Password = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  const [type, setType] = useState('password');
  return (
    <div className={classes.InputContainer}>
      <label htmlFor={props.name}>
        {label} {props.required ? <span className='red'>*</span> : null}
      </label>
      <div className={classes.PasswordInput}>
        <input type={type} {...field} {...props} id={props.name} autoComplete='new-password' />
        {meta.touched && meta.error ? <div className='error'>{meta.error}</div> : null}
        {type === 'password' ? (
          <i class='fa fa-eye' onClick={() => setType('text')} />
        ) : (
          <i class='fa fa-eye-slash' onClick={() => setType('password')} />
        )}
      </div>
    </div>
  );
};
export const Checkbox = ({ label, labelClassName, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div>
      <input className={props.className ? props.className : classes.CheckboxField} type="checkbox" checked={field.value} {...field} {...props} id={props.name} />
      {meta.touched && meta.error ? <div className='error'>{meta.error}</div> : null}
      <label
        htmlFor={props.name}
        className={labelClassName ? labelClassName : classes.InputContainerLabel}
      >
        {label} {props.required ? <span className='red'>*</span> : null}
      </label>
    </div>
  );
};

export const NonFormikDropdownComponent = ({
  label,
  defaultValue = null,
  disabled = false,
  sortByLabel = false,
  fireCallbackOnInit = false,
  setNullForNoDefaultValue = false,
  className = null,
  values = [],
  labelClassName,
  ...props
}) => {
  // const [field, meta] = useField(props);
  const init = defaultValue ? values.filter((each) => defaultValue === each.value)[0] : '';
  const [value, setValue] = useState(init);
  // const { submitCount } = useFormikContext();

  const mounted = useRef();

  useEffect(() => {
    setValue('');
    // if (value && !mounted.current) props.setFieldValue(props.name, value.value);

    if (!mounted.current && !fireCallbackOnInit) mounted.current = true;
    else if (props.callback && value) props.callback(value.value, value?.label);
  }, [values]);

  useEffect(() => {
    if (defaultValue || defaultValue === 0 || defaultValue === false || defaultValue === '') {
      console.log('DEFAULT', defaultValue);
      const val = values.filter((each) => defaultValue == each.value)[0];
      if (setNullForNoDefaultValue && !val?.value) {
        // props.setFieldValue(props.name, null);
        setValue('');
      } else if (val) {
        // props.setFieldValue(props.name, val?.value);
        setValue(val);
      }
    }
  }, [defaultValue, values]);

  const handleDropdownChange = (e) => {
    console.log(e);
    // props.setFieldValue(props.name, e.value);
    setValue(e);
    if (props.callback) props.callback(e.value, e.label);
  };

  return (
    <div className={' Input'}>
      <div className={classes.Dropdown}>
        <label htmlFor={props.name} className={labelClassName ? labelClassName : classes.InputLabel}>
          {label} {props.required ? <span className='red'>*</span> : null}
        </label>
        <Select
          // menuIsOpen
          key={props.name}
          value={value}
          styles={{ ...colourStyles, menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
          options={sortByLabel ? sortBy(values, 'label') : values}
          onChange={handleDropdownChange}
          placeholder={props.placeholder || 'Select ' + label}
          isDisabled={disabled}
        />
      </div>
    </div>
  );
};

export const RadioButtons = ({ label, setFieldValue, color, ...props }) => {
  const [field, meta] = useField(props);
  useEffect(() => {
    if (!get(props.values, props.name)) setFieldValue(props.name, props.options[0].value);
  }, []);
  return (
    <div className={classes.InputContainer}>
      <label htmlFor={props.name}>
        {label} {props.required ? <span className='red'>*</span> : null}
      </label>
      <div className={classes.RadioButtons} id={props.name}>
        {props.options.map((option, i) => (
          <div class={color ? `${classes.radioItem}  ${classes[color]}` : `${classes.radioItem}`}>
            <input
              type='radio'
              {...field}
              id={props.name + option.value}
              value={option.value}
              defaultChecked={get(props.values, props.name) ? get(props.values, props.name) === option.value : i === 0}
              disabled={props.disabled}
            />
            <label for={props.name + option.value}>{option.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};